<template>
  <div class="rj-page-card">
    <!-- <div class="rj-page-card__title">电汇查询</div> -->
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="实际付款人名称:" prop="drawee">
          <el-input v-model="searchForm.drawee" placeholder="请输入实际付款人名称" />
        </el-form-item>
        <el-form-item label="汇入公司:" prop="importCompany">
          <el-input v-model="searchForm.importCompany" placeholder="请输入汇入公司" />
        </el-form-item>
        <el-form-item label="汇入银行:" prop="importBank">
          <el-input v-model="searchForm.importBank" placeholder="请输入汇入银行" />
        </el-form-item>
        <el-form-item label="付款用途:" prop="remittanceScenario">
          <el-select v-model="searchForm.remittanceScenario" placeholder="请选择" clearable>
            <el-option v-for="(item,val) of remittanceScenarioOptions" :key="val" :value="val" :label="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款日期:" prop="remittanceStartTime">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.remittanceStartTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.remittanceEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="客户名称:" prop="userName">
          <el-input v-model="searchForm.userName" placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item label="付款方式:" prop="remittanceWay">
          <el-select v-model="searchForm.remittanceWay" placeholder="请选择" clearable>
            <el-option v-for="(item,val) of remittanceWayOptions" :key="val" :value="val" :label="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态:" prop="remittanceState">
          <el-select v-model="searchForm.remittanceState" placeholder="请选择" clearable>
            <el-option v-for="item in remittanceStateOptions" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="汇款编号:" prop="importBank">
          <el-input v-model="searchForm.telegraphicTransferNo" placeholder="请输入汇款编号" />
        </el-form-item>
        <el-form-item label="币种:" prop="currencyName">
          <el-select v-model="searchForm.currencyName" placeholder="请选择">
            <el-option label="美元" value="美元" />
            <el-option label="马币" value="马币" />
            <el-option label="日元" value="日元" />
            <el-option label="人民币" value="人民币" />
          </el-select>
        </el-form-item>
        <el-form-item label="收款单号:" prop="telegraphicTransferNum">
          <el-input v-model="searchForm.telegraphicTransferNum" placeholder="请输入资管收款单号" />
        </el-form-item>
        <el-form-item label="是否委托付款:" prop="entrustedFlg">
          <el-select v-model="searchForm.entrustedFlg" placeholder="请选择">
            <el-option label="是" value="1" />
            <el-option label="否" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="doSearch">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm('searchForm')">
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="tableLoading" class="tableBody">
        <div class="operate-btn-wrap">
          <el-button type="primary" :loading="submitLoading" @click="exportExcel">
            导出汇款信息
          </el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column type="selection" width="50" align="left" fixed="left" />
          <el-table-column prop="telegraphicTransferNo" label="汇款编号" align="left" width="140px" fixed="left" />
          <el-table-column prop="importCompany" label="汇入公司" align="left" width="160px" />
          <el-table-column prop="importBank" label="汇入银行" align="left" width="160px" />
          <el-table-column prop="remittanceAmount" label="付款金额" align="right" header-align="left" width="120" />
          <el-table-column prop="currencyName" label="币种" align="left" />
          <el-table-column prop="sourceCompany" label="客户名称" align="left" width="140px" />
          <el-table-column prop="drawee" label="实际付款人名称" align="left" width="140px" />
          <el-table-column prop="remittanceTime" label="付款日期" align="left" width="140px" />
          <el-table-column prop="actualRemittanceAmount" label="实际到账金额" min-width="110" align="right" header-align="left" />
          <el-table-column prop="serviceFee" label="手续费" align="right" header-align="left" />
          <el-table-column prop="strRemittanceScenario" label="付款用途" align="left" />
          <el-table-column prop="strRemittanceType" label="付款类型" align="left" min-width="100" />
          <el-table-column prop="strRemittanceWay" label="付款方式" align="left" />
          <el-table-column prop="telegraphicTransferNum" label="收款单号" min-width="140" align="left">
            <template v-slot="{row}">
              <span v-if="row.telegraphicTransferNum === ''">-</span>
              <span v-else>{{ row.telegraphicTransferNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualRemittanceAmount" label="实际到款金额" min-width="100" align="right" header-align="left">
            <template v-slot="{row}">
              <span v-if="row.actualRemittanceAmount === ''">-</span>
              <span v-else>{{ row.actualRemittanceAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="entrustedFlg" label="是否委托付款" width="100" align="left">
            <template v-slot="{row}">
              <span v-if="row.entrustedFlg === ''">-</span>
              <span v-if="row.entrustedFlg === 1">是</span>
              <span v-if="row.entrustedFlg === 0">否</span>
            </template>
          </el-table-column>>
          <el-table-column prop="strRemittanceState" label="状态" align="left" width="110px">
            <template v-slot="{row}">
              {{ row.strRemittanceState }}
            </template>
          </el-table-column>

          <el-table-column prop="availableAmount" label="可用余额" min-width="110" align="right" header-align="left" />

          <el-table-column prop="isReceipt" label="已生成收款单" align="left" width="100px">
            <template v-slot="{row}">
              <span v-if="row.isReceipt">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="确认收款" width="100" align="left" fixed="right">
            <template v-slot="{row}">
              <el-button v-if="row.remittanceState!==0 &&row.remittanceState!==-1" type="text" @click="showInfo(row)">
                确认
              </el-button>
              <el-button v-if="row.remittanceState!==0 && row.remittanceState!==-1" type="text" @click="reject(row)">
                废弃
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
import { getFinalCustomerInfoList, abandonedTelegraphicTransfer } from '@/API/index';
import { listTelegraphicTransferInternation } from '@/API/international';

import axios from '@/API';
import { formatDate } from '@/libs/util.js';
export default {
  data () {
    return {
      Currency1: '',
      Receiptnumber: '',
      Whethertodelegatepayment: '',
      remittanceStateOptions: [
        {
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '待确认到账'
        }, {
          value: '2',
          label: '待核查户到账'
        }, {
          value: '3',
          label: '一般户到账'
        }, {
          value: '4',
          label: '未收到LC'
        }, {
          value: '5',
          label: '收到LC正本'
        }, {
          value: '6',
          label: '确认到账'
        }],
      // currencyName: '', // 币种
      // telegraphicTransferNum: '', // 收款单号
      // entrustedFlg: '', // 是否委托
      searchForm: {
        drawee: '',
        importCompany: '',
        remittanceStartTime: '',
        remittanceEndTime: '',
        remittanceState: '',
        remittanceScenario: '',
        remittanceWay: '',
        importBank: '',
        telegraphicTransferNo: '',
        currencyName: '', // 币种
        telegraphicTransferNum: '', // 收款单号
        entrustedFlg: '' // 是否委托
        // userName: ''
      },
      name: '',
      tableData: [],
      customerOptions: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      loading: false,
      list: [],
      submitLoading: false
    };
  },
  computed: {
    ...mapState({
      businessNameList: state => state.enumeration.businessNameList, //  业务实体列表-来款记录查询(财务)
      importCompanyList: state => state.enumeration.importCompanyList, //  银行账号信息列表-来款记录查询(财务)
      getBankInfoList: state => state.enumeration.getBankInfoList, // 根据供货单位ID获取银行列表
      remittanceScenarioOptions: state => state.enumeration.remittanceScenarioOptions,
      remittanceWayOptions: state => state.enumeration.remittanceWay
    })
  },
  methods: {
    ...mapActions('enumeration', [
      'initBusinessNameList',
      'initImportCompanyList',
      'getBankInfo'
    ]),
    financeremList () {
      let params = {
        ...this.searchForm,
        pageSize: this.page.pageSize,
        pageIndex: this.page.currentPage
      };
      this.tableLoading = true;

      listTelegraphicTransferInternation(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
        this.tableLoading = false;
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    doSearch () {
      this.page.currentPage = 1;
      this.financeremList();
    },
    resetForm () {
      this.searchForm.remittanceEndTime = '';
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.financeremList();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.financeremList();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.financeremList();
    },
    showInfo (row) {
      this.$router.push({
        'name': 'ConfirmReceipt',
        params: {
          id: row.id
        }
      });
    },
    reject (row) {
      this.$confirm('废弃后代理商将不能再进行分配，你确定要废弃此来款吗？', '', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        abandonedTelegraphicTransfer(row.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.doSearch();
          }
        }).catch((res) => {

        });
      }).catch(() => {
      });
    },
    // 输入文字获取最终客户名称
    remoteMethod (query) {
      if (query !== '') {
        getFinalCustomerInfoList(query).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.customerOptions = json.data;
          }
        }).catch((res) => {

        });
      }
    },
    exportExcel () {
      this.submitLoading = true;
      this.currentPage = 1;
      axios.post('/telegraphicTransferInternation/financeExportTelegraphicTransfer', { ...this.searchForm }, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        let date = new Date();
        date = formatDate(date, 'yyyy-MM-dd');
        const fileName = '电汇列表' + date + '.xlsx';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    }
  },
  mounted () {
    // this.initBusinessNameList();
    // this.getBankInfo();
    this.financeremList();
    this.$store.dispatch('enumeration/initremittance');
  }
};
</script>
<style lang="scss">
</style>
